import React from 'react';
import {useTranslation} from 'react-i18next';
import {ViewMode} from '@taopix/taopix-core';
import {PageInterface} from '@taopix/taopix-core/dist/types/types';
import {Button, EditBoxIcon} from '@taopix/taopix-design-system';
import {UserInterfaceActions} from '../../Context/UserInterface/UserInterfaceActionTypes';
import useViewMode from '../../../Hooks/useViewMode';
import {useExperience} from '../../Experience/ExperienceProvider';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {useTaopix} from '../../Context/TaopixContext';

const EditPageButton = ({page, buttonProps}) => {
  const app = useTaopix();
  const ui = useUiState();
  const {experience} = useExperience();
  const [, setViewMode] = useViewMode();
  const {t} = useTranslation(['stubar', 'autofill']);

  const viewModes = [
    experience.EDITOR.workArea.editingViewModes.list,
    experience.EDITOR.workArea.editingViewModes.grid,
    experience.EDITOR.workArea.editingViewModes.page,
  ];

  const onEditPage = (page?: PageInterface) => {
    // Close the page actions palette if it is open
    if (ui.state.palette.section === 'pageActionsPalette') {
      ui.dispatch(UserInterfaceActions.setToolPaletteSection(null));
    }
    if (viewModes.filter(Boolean).length > 1) {
      // Set the core to the requested page
      if (page) app.core.get('abilities').setPage(page.pagenumber).then();

      // if grid is the default view, attempt to choose list, otherwise single
      if ('gv' === experience.EDITOR.workArea.defaultView) {
        if (experience.EDITOR.workArea.editingViewModes.list) {
          setViewMode(ViewMode.List);
          return void 0;
        }
        if (experience.EDITOR.workArea.editingViewModes.page) {
          setViewMode(ViewMode.Single);
          return void 0;
        }
      } else {
        const mode =
          experience.EDITOR.workArea.defaultView === 'ls' ? ViewMode.List : ViewMode.Single;
        setViewMode(mode);
        return void 0;
      }
    }
  };

  return (
    <Button
      {...buttonProps}
      label={t('*:str_LabelPageEdit')}
      startIcon={<EditBoxIcon />}
      labelLines={1}
      onClick={() => onEditPage(page)}
    />
  );
};

export default EditPageButton;
